import { useHasProfile } from "@dexteel/mesf-core";
import { CarrierStatusCode } from "../models/Carrier";
import {
	CARRIER_POLICY,
	CarrierActionKey,
	CarrierProfile,
	PROFILE_HIERARCHY,
} from "./carrierPolicy";

const PROFILE_RANK = new Map<CarrierProfile, number>(
	PROFILE_HIERARCHY.map((p, i): [CarrierProfile, number] => [p, i]),
);

export type CarrierAction = {
	key: CarrierActionKey;
	minProfile: CarrierProfile | null;
	allowed: boolean;
	requirementLabel: string;
};

export const useCarrierPolicy = () => {
	const hasProfile = useHasProfile();

	const rank = PROFILE_HIERARCHY.reduce(
		(highest, profile) =>
			hasProfile(profile) ? PROFILE_RANK.get(profile)! : highest,
		-1,
	);

	const actionsFor = (status?: CarrierStatusCode): CarrierAction[] => {
		if (!status) return [];

		return Object.entries(CARRIER_POLICY[status] ?? {}).map(
			([key, profile]) => {
				const minProfile = profile ?? null;
				return {
					key: key as CarrierActionKey,
					minProfile,
					allowed: minProfile === null || rank >= PROFILE_RANK.get(minProfile)!,
					requirementLabel:
						minProfile === null ? "" : `Requires ${minProfile} or superior`,
				};
			},
		);
	};

	return { actionsFor, rank };
};
